module.exports = __webpack_public_path__ + "static/powerbi-merge-values-replace-2-8b9140398ce317312dcea3a3ac1933bc.png";